import validator from '@rjsf/validator-ajv8';
import { steps, stepsMap } from '../config-wizard-steps';

export const generateStepSchema = (step, data, changes) => (step.schemaFunction ? step.schemaFunction(data, changes) : step.schema);

export const getUiSchemaBasedOnSchemaAttributes = (schema, step) => (step.updateUiSchema ? step.updateUiSchema(schema, step.uiSchema) : step.uiSchema);

export const validateStep = (stepReference, allWizardFormData, changes) => {
  if (!allWizardFormData || !changes) {
    return false;
  }

  let step;
  let stepId;
  if (typeof stepReference === 'number') {
    step = steps[stepReference];
    stepId = step.id;
  } else if (typeof stepReference === 'string') {
    step = stepsMap[stepReference];
    stepId = stepReference;
  } else {
    return false;
  }

  if (step.nonFunctional) {
    return true;
  }

  const formData = changes.get(stepId) || allWizardFormData[stepId];

  if (!formData) {
    return true;
  }

  const schema = generateStepSchema(step, allWizardFormData, changes.get(stepId));

  let isValid;
  if (step.validateFunction) {
    isValid = step.validateFunction(schema, formData, allWizardFormData, changes);
  } else {
    isValid = validator.isValid(schema, formData, schema);
  }

  return isValid;
};

export const BRAND_MODEL_UI_SCHEMA = {
  'ui:options': {
    title: '',
    description: '',
  },
  brand: {
    'ui:widget': 'hidden',
  },
  model: {
    'ui:title': 'Model',
  },
};

export const isReadyToSave = (data, changes) => steps.every((step) => validateStep(step.id, data, changes));
